"use client";

import { withFallback } from "../with-fallback";

export const BalancesElement = withFallback({
	displayName: "BalancesElement",
	type: "balances-element",
} as const);
